module.exports = require("http");


//////////////////
// WEBPACK FOOTER
// external "http"
// module id = 17
// module chunks = 0